import type { ToOptions } from '@tanstack/react-router'
import {Button} from 'react-aria-components'

import AeroplaneSvg from '@/assets/flight/icons/aeroplane.svg?react'
import DeliverySvg from '@/assets/food/icons/delivery.svg?react'
import LogoutSvg from '@/assets/icons/logout.svg?react'
import AddressSvg from '@/assets/icons/manage-address.svg?react'
import OrderSvg from '@/assets/icons/order.svg?react'
import RewardsSvg from '@/assets/icons/rewards.svg?react'
import UserSvg from '@/assets/icons/user.svg?react'
import LogoutDialog from '@/auth/components/LogoutDialog'
import SkipLink from '@/components/SkipLink'
import Footer from '@/layout/Footer'
import Navbar from '@/layout/Navbar'
import {
  AddressesRoute,
  FlightsRoute,
  FoodOrdersRoute,
  OrdersRoute,
  ProfileRoute,
  RewardsRoute,
} from '@/routeRegistry'
import skipTargetProps from '@/utils/a11y/skipTargetProps'
import {useIsMobile} from '@/utils/hooks/useWindowSize'

import style from './Account.module.scss'

interface MenuItem {
  label: string
  Icon: ElementType
  to: ToOptions['to']
}

const MENU_ITEMS: MenuItem[] = [
  {
    label: 'Profile',
    Icon: UserSvg,
    to: ProfileRoute.fullPath,
  },
  {
    label: 'Orders',
    Icon: OrderSvg,
    to: OrdersRoute.fullPath,
  },
  {
    label: 'Flights',
    Icon: AeroplaneSvg,
    to: FlightsRoute.fullPath,
  },
  // {
  //   label: 'Food Orders',
  //   Icon: DeliverySvg,
  //   to: FoodOrdersRoute.fullPath,
  // },
  {
    label: 'Rewards',
    Icon: RewardsSvg,
    to: RewardsRoute.fullPath,
  },
  {
    label: 'Addresses',
    Icon: AddressSvg,
    to: AddressesRoute.fullPath,
  },
]

const LogoutButton = memo(function LogoutButton() {
  return (
    <Button className={clsx(style.Logout)} aria-haspopup='dialog'>
      <LogoutSvg aria-hidden />
      Logout
    </Button>
  )
})

export default memo(function Account() {
  const isMobile = useIsMobile()

  return (
    <div className={style.Page}>
      <SkipLink title='Skip to main content' to='#main-content' />
      <Navbar variant='dark' />
      <div className={style.Layout}>
        {!isMobile && (
          <nav className={style.Navigation}>
            {MENU_ITEMS.map(({label, Icon, to}) => (
              <Link
                key={label}
                to={to}
                className={style.NavigationItem}
                activeProps={{
                  'className': style.Active,
                  'aria-current': true,
                }}
              >
                <Icon />
                {label}
              </Link>
            ))}
            <div className={style.Bottom}>
              {/* TODO: when logged out, redirect to homepage */}
              <LogoutDialog>
                <LogoutButton />
              </LogoutDialog>
            </div>
          </nav>
        )}
        <main className={style.MainContent} {...skipTargetProps('main-content')}>
          <Outlet />
        </main>
      </div>
      <Footer />
    </div>
  )
})
